import { AnchorHTMLAttributes } from 'react';
import LinkIcon from '@mui/icons-material/Link';
import Typography from '@mui/material/Typography';

import { LinkStyled } from './styled';

type ExternalLinkProps = {
  text: string;
  redirectUrl: string;
  isIcon?: boolean;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

export default function ExternalLink({ text, redirectUrl, isIcon = false, ...rest }: ExternalLinkProps) {
  return (
    <LinkStyled href={redirectUrl} target="_blank" rel="noopener" {...rest}>
      {isIcon && <LinkIcon sx={{ pr: 1 }} />}
      <Typography
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textWrap: 'nowrap',
        }}
        fontSize={14}
      >
        {text}
      </Typography>
    </LinkStyled>
  );
}
